export default __webpack_public_path__ + "static/media/CalendlyLogo.cbe7b1fc.svg";